export default __webpack_public_path__ + "static/media/refresh.493505f9.svg";